const search = window.location.search.split(/[?=&]/);

export default function qs(segment) {
  if (search.indexOf(segment) === -1) {
    return undefined;
  }

  return decodeURIComponent(search[search.indexOf(segment) + 1]);
}



// WEBPACK FOOTER //
// ./src/js/lib/qs.js